import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("legend", { class: "form__legend form__legend--yellow" }, "Calculate image size", -1)
const _hoisted_2 = { class: "form__wrapper" }
const _hoisted_3 = { class: "form__item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form__label",
  for: "calc-size-ratio"
}, [
  /*#__PURE__*/_createTextVNode(" Ratio"),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory" }, "*")
], -1)
const _hoisted_5 = { class: "form__item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form__label",
  for: "calc-size-width"
}, "Width", -1)
const _hoisted_7 = { class: "form__item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form__label",
  for: "calc-size-sizeeight"
}, "Height", -1)
const _hoisted_9 = { class: "form__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "form__input",
          id: "calc-size-ratio",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ratio) = $event)),
          placeholder: "16:9",
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.calculateSize && _ctx.calculateSize(...args)))
        }, null, 544), [
          [_vModelText, _ctx.ratio]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          class: "form__input",
          id: "calc-size-width",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.width) = $event)),
          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.calculateHeight && _ctx.calculateHeight(...args)))
        }, null, 544), [
          [_vModelText, _ctx.width]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          class: "form__input",
          id: "calc-size-sizeeight",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.height) = $event)),
          onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.calculateWidth && _ctx.calculateWidth(...args)))
        }, null, 544), [
          [_vModelText, _ctx.height]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "button button--yellow",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
        }, "Reset Form")
      ])
    ])
  ], 32))
}